import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { AnalyticsListener as AKAnalyticsListener } from '@atlaskit/analytics-next';
import PropTypes from 'prop-types';
import * as React from 'react';
import { EVENT_CHANNEL } from "../../../constants/analytics/events";
export default class AnalyticsListener extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onEvent", event => {
      const _this$props = this.props,
        {
          children
        } = _this$props,
        attributes = _objectWithoutProperties(_this$props, _excluded);
      event.update(payload => _objectSpread(_objectSpread({}, payload), {}, {
        attributes: _objectSpread(_objectSpread({}, payload.attributes), attributes)
      }));
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(AKAnalyticsListener, {
      channel: EVENT_CHANNEL,
      onEvent: this.onEvent
    }, this.props.children);
  }
}
_defineProperty(AnalyticsListener, "propTypes", {
  children: PropTypes.node.isRequired
});